import {Media} from "./Media";
import {DocumentAchatService} from "@/xhttp/DocumentAchatService";
import {XHTTP} from "@/shared/xhttp";
import {Achat} from "@/models/Achat";

@XHTTP(DocumentAchatService, '/documentachats')
export class DocumentAchat {

    private _id: number;
    private _media: Media;
	private _achat: Achat;
    private _createdAt: Date;

    /////////////
    // Getters //
    /////////////

    public get id(): number {
        return this._id;
    }

    public get media(): Media {
        return this._media;
    }

	public get achat(): Achat {
		return this._achat;
	}

    public get createdAt(): Date {
        return this._createdAt;
    }

    /////////////
    // Setters //
    /////////////

    public set media(value: Media) {
        this._media = value;
    }

	public set achat(value: Achat) {
		this._achat = value;
	}

    ///////////////
    // Serialize //
    ///////////////

    public fromJSON(data: any): this {
        this._id        = data.id;
        this._media     = (new Media()).fromJSON(data.media);
        this._createdAt = data.createdAt ? new Date(data.createdAt) : null;
        return this;
    }
}
